











































































































































import {Component, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";

/**
 * Görsel ayarlar bloğu ("visual").
 *
 * DİKKAT: Panelin axios katmanı boolean'ları "true"/"false" string'ine
 * çeviriyor ve PHP'de "false" truthy oluyor. Bu yüzden tüm anahtarlar
 * :true-value="'1'" :false-value="'0'" ile "1"/"0" olarak gönderilir.
 *
 * DİKKAT 2: Config::upsert() tam değiştirme yapar — form bu bloğun TÜM
 * alanlarını göndermek zorunda. get() taze sınıf üzerine beyaz-liste ile
 * kopyalar, böylece sunucudan gelen _site_id gibi alanlar forma sızmaz.
 */
class visualConfig {
    svgEnabled: string = "1";
    svgMobile: string = "1";
    heroSvgVariant: string = "brain";
    patternOpacity: string = "5";
    accentColor: string = "#54B8E3";
    animEnabled: string = "1";
    animHero: string = "1";
    animBenefits: string = "1";
    animMetrics: string = "1";
    animCounter: string = "1";
    animProcess: string = "1";
    animNews: string = "1";
    animContact: string = "1";
    /** Ana sayfa slaytı süresi, saniye (3–30); sitede data-delay olarak ms'ye çevrilir */
    sliderDelay: string = "8";
}

const SLIDER_MIN = 3;
const SLIDER_MAX = 30;
const SLIDER_DEFAULT = 8;

/**
 * Sitedeki Visual::sliderDelaySeconds() ile aynı yorum: boş/bozuk → 8,
 * "7,5" kabul, yanlışlıkla ms girilmişse (8000) saniyeye çevrilir, 3–30'a
 * sıkıştırılır. Panel kaydırıcısı tam saniye kullanır.
 */
function clampSeconds(value: any): number {
    const text = value === undefined || value === null ? "" : String(value).trim().replace(",", ".");
    let n = window.Number(text);
    if (text === "" || isNaN(n)) {
        return SLIDER_DEFAULT;
    }
    if (n >= 1000) {
        n = n / 1000;
    }
    return Math.min(SLIDER_MAX, Math.max(SLIDER_MIN, Math.round(n)));
}

@Component({
    components: {EForm}
})
export default class GorselAyarlar extends Vue {
    action: string = "config/visual";
    data: visualConfig = new visualConfig();
    sliderMin: number = SLIDER_MIN;
    sliderMax: number = SLIDER_MAX;

    heroVariants = [
        {text: "Beyin bağlantı ağı", value: "brain"},
        {text: "Nöron çizgileri", value: "neural"},
        {text: "Görsel yok", value: "none"},
    ];

    sections = [
        {key: "animHero", label: "Üst alan (hero)"},
        {key: "animBenefits", label: "Faydalar"},
        {key: "animMetrics", label: "Ölçümlemeler"},
        {key: "animCounter", label: "Sayaçlar"},
        {key: "animProcess", label: "Kimler faydalanır"},
        {key: "animNews", label: "Blog"},
        {key: "animContact", label: "İletişim"},
    ];

    /** Slider yüzde ile çalışır, ayar string olarak saklanır */
    get patternPercent(): number {
        const n = window.Number(this.data.patternOpacity);
        return isNaN(n) ? 5 : (n <= 1 ? Math.round(n * 100) : n);
    }

    set patternPercent(value: number) {
        this.data.patternOpacity = String(value);
    }

    get sliderSeconds(): number {
        return clampSeconds(this.data.sliderDelay);
    }

    set sliderSeconds(value: number) {
        this.data.sliderDelay = String(clampSeconds(value));
    }

    async get() {
        let response = await this.$http.get(this.action);
        let fresh = new visualConfig();
        Object.keys(fresh).forEach((key: string) => {
            if (response.data && typeof response.data[key] !== "undefined" && response.data[key] !== null) {
                (fresh as any)[key] = String(response.data[key]);
            }
        });
        // Elle bozulmuş kayıt formda düzeltilmiş görünsün ve öyle kaydedilsin
        fresh.sliderDelay = String(clampSeconds(fresh.sliderDelay));
        this.data = fresh;
    }

    created() {
        this.get();
    }
}
